import React, { useState, useEffect, useRef } from "react";
import DashBoardTable from "../ProGridTable/DashBoardTable";
import { getApi } from '../../../../utils/services'
import { PREVAILING_WAGE_GAUGE_DATA } from '../../../../utils/services/apiPath'
import { errorToast } from "../../../../utils/toastHelper";

const PrevailingWageRisk = ({ selectedProjectsQuery }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetchedData = useRef(false);
  const columns = [
    { field: "projectName", headerName: "Project" },
    { field: "partnerName", headerName: "Partner" },
    { field: "pwJobsCount", headerName: "# of Prevailing Wage Jobs" },
    // { field: "clrCounts", headerName: "Number  of Conformance Labor Requests/ Approved CLRs" },
    { field: "pwUnderpaymentsCount", headerName: "Prevailing Wage Underpayment" }
  ];

  const fetchPrevailingWageRiskData = async () => {
    try {
      setLoading(true);
      const { data } = await getApi(`${PREVAILING_WAGE_GAUGE_DATA}?projectIds=${selectedProjectsQuery}`);

      const rowsWithId = data.map((item, index) => ({
        ...item,
        id: item.projectId || `fallback-id-${index}`,
      }));
      setRows(rowsWithId);
      setLoading(false);
    } catch (error) {
      errorToast(error)
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchPrevailingWageRiskData();
    }
  }, []);


  return (
    <div style={{ marginTop: "20px" }}>
      <DashBoardTable columns={columns} rows={rows} paginationModel={{ page: 0, pageSize: 5 }} hideExport={false} checkboxSelection={false} loading={loading} />
    </div>
  );
};

export default PrevailingWageRisk;
